import Fetch, { fetchConfig } from '@/hooks/fetch';
import paging, { pagingHookConfig } from '@/hooks/paging';
import { states } from '@/constants/lifecycle';
import actions from '../constants';

export default {
  useFetchTaskTemplates: ({ category }, readStatus, config = pagingHookConfig()) => paging.useDispatchByCategory(
    actions.FETCH_TASK_TEMPLATES,
    category,
    readStatus,
    config,
  ),
  useFetchTaskTemplateForTask: ({
    category,
    code,
    taskCode,
    templateReadStatus,
  }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_TASK_TEMPLATE_FOR_TASK,
    states.NONE,
    { category, taskCode, code },
    fetchConfig([code], () => templateReadStatus === states.NONE && readStatus === states.SUCCESS),
  ),
};
